import { get } from "../config/api";

export const filterSubDistrictsandFOT = (inputArray) => {
  const result = { subdist: [], fot: [] };
  const subdistSet = new Set(); // To track unique subdistrict entries
  const fotSet = new Set(); // To track unique FOT entries

  inputArray.forEach((item) => {
    if (item.sub_district && item.sub_district_id) {
      const subdistKey = `${item.sub_district}-${item.sub_district_id.trim()}`;
      if (!subdistSet.has(subdistKey)) {
        subdistSet.add(subdistKey);
        result.subdist.push({
          subdist: item.sub_district,
          subdistID: item.sub_district_id.trim(),
          relatedFT: item.fot_id,
        });
      }
    }
    if (item.fot_id && item.fot) {
      const fotKey = `${item.fot_id}-${item.fot}`;
      if (!fotSet.has(fotKey)) {
        fotSet.add(fotKey);
        result.fot.push({ fot: item.fot, fotid: item.fot_id });
      }
    }
  });
  return result;
};

// Renamed from getStates to getBibhags
export const getBibhags = async () => {
  let BibhagsData = [];
  BibhagsData = [
    { state_code: "10", state_name: "Barisal" },
    { state_code: "20", state_name: "Chattogram" },
    { state_code: "30", state_name: "Dhaka" },
    { state_code: "40", state_name: "Khulna" },
    { state_code: "45", state_name: "Mymensingh" },
    { state_code: "50", state_name: "Rajshahi" },
    { state_code: "55", state_name: "Rangpur" },
    { state_code: "60", state_name: "Sylhet" },
  ];
  const newData = BibhagsData.map((item, i) => ({
    id: item["state_code"],
    value: item["state_name"],
  }));
  return newData.sort((a, b) => {
    return a.value.localeCompare(b.value);
  });
};

// Renamed from getDistrict to getZila
export const getZila = async (bibhagCode) => {
  let ZilaData = [];
  await get(`/locations/zila?bibhag_code=${bibhagCode}`).then(async (data) => {
    ZilaData = data;
  });
  const newData = ZilaData.map((item, i) => ({
    id: item["zila_code"],
    value: item["zila"],
  }));
  return newData.sort((a, b) => {
    return a.value.localeCompare(b.value);
  });
};

// Renamed from getSubDistrict to getUpazila
export const getUpazila = async (zilaCode) => {
  let UpazilasData = [];
  await get(`/locations/upazila?zila_code=${zilaCode}`).then(
    async (data) => {
      UpazilasData = data;
    }
  );
  const newData = UpazilasData.map((item, i) => ({
    id: item["upazila_code"],
    value: item["upazila"],
  }));
  return newData.sort((a, b) => {
    return a.value.localeCompare(b.value);
  });
};

export const getVillages = async (upazilaCode) => {
  let villegesData = [];
  await get(
    `/locations/villages?sub_district_code=${ // Keep 'sub_district_code' for API if that's what it expects
      upazilaCode.length === 9 ? "0" + upazilaCode : upazilaCode
    }`
  ).then(async (data) => {
    villegesData = data;
  });
  const newData = villegesData.map((item, i) => ({
    id: item["village_code"],
    value: item["village_name"],
    ...item,
  }));
  return newData.sort((a, b) => {
    return a.value.localeCompare(b.value);
  });
};

// Renamed from getTerritoriesBySubDistrict to getTerritoriesByUpazila
export const getTerritoriesByUpazila = async (upazilaCode) => {
  let territories = {};
  await get(`/locations/territory?upazila_code=${upazilaCode}`).then(
    async (data) => {
      territories = data;
    }
  );
  return territories;
};

export const getUrbanBodies = async (upazilaCode) => {
  let UrbanBodiesData = [];
  await get(
    `/locations/urban-bodies?sub_district_code=${ // Keep 'sub_district_code' for API if that's what it expects
      upazilaCode.length === 9 ? "0" + upazilaCode : upazilaCode
    }`
  ).then(async (data) => {
    UrbanBodiesData = data;
  });
  const newData = UrbanBodiesData.map((item, i) => ({
    id: item["urban_body_code"],
    value: item["urban_body_name"],
    ...item,
  }));
  return newData.sort((a, b) => {
    return a.value.localeCompare(b.value);
  });
};

export const getTerritoryAndFOT = async (data) => {
  return { territory: data.territory_name, fot: data.fot_name, ...data };
};

export const getTerritoryAndFOTForUrbanBody = async (territory_id) => {
  let FOTdetail = {};
  await get(`/locations/fot-mappings?territory_code=${territory_id}`).then(
    async (data) => {
      FOTdetail = data;
    }
  );
  const newData =
    (await FOTdetail) &&
    FOTdetail.fots.map((item, i) => ({
      id: item["fot_code"],
      value: item["fot_name"],
    }));
  return { territory_name: FOTdetail.territory_name, fots: newData };
};

function groupResponsesByQuestionId(data) {
  const groupedResponses = {};
  data.responses.forEach((response) => {
    const { question_id, response: responseObj } = response;
    if (!groupedResponses[question_id]) {
      groupedResponses[question_id] = { question_id, response: {} };
    }
    Object.assign(groupedResponses[question_id].response, responseObj);
  });
  return Object.values(groupedResponses);
}

export const restructureAnswers = (config, answers) => {
  const outputObject = {};
  answers.forEach((item) => {
    outputObject[item.identifier] = item.answer;
  });

  const restructuredData = {
    responses: [],
  };

  const configMap = {};
  config.forEach((section, sectionIndex) => {
    if (section.sectionquestions) {
      section.sectionquestions.forEach((subSection) => {
        subSection.questions.forEach((question) => {
          configMap[question.identifier] = { sectionIndex, ...question };
        });
      });
    } else {
      section.questions.forEach((question) => {
        configMap[question.identifier] = { sectionIndex, ...question };
      });
    }
  });

  const groupedResponses = {};
  answers.forEach((answer) => {
    const questionConfig = configMap[answer.identifier];
    const { sectionIndex } = questionConfig;
    if (!groupedResponses[sectionIndex]) {
      groupedResponses[sectionIndex] = [];
    }
    groupedResponses[sectionIndex].push({
      question_id: sectionIndex + 1 + "",
      response: {
        [questionConfig.identifier]: answer.answer,
      },
    });
  });

  const flattenedResponses = [];
  for (const sectionIndex in groupedResponses) {
    flattenedResponses.push(...groupedResponses[sectionIndex]);
  }
  restructuredData.responses = flattenedResponses;

  const groupedData = groupResponsesByQuestionId(restructuredData);
  return groupedData;
};
